import { createDynamicSlice } from ".";
import { fetchSectionsThunk } from "../thunks/sectionsThunk";

export const sectionsSlice = createDynamicSlice({
  name: "sections",
  thunk: fetchSectionsThunk,
  listMode: true,
  resetActionName: "resetSections",
});

export const sectionsReducer = sectionsSlice.reducer;
export const { resetSections } = sectionsSlice.actions;
